<button *ngFor="let option of options()"
        type="button"
        class="xp-toggle-buttons__button"
        [class.xp-toggle-buttons__button--selected]="isSelected(option.value)"
        [attr.aria-pressed]="isSelected(option.value)"
        (click)="toggled.emit(option.value)">{{ option.label }}</button>
